import { get } from 'lodash';

/**
 * Returns a prop by key preferring Redux-form 7 props, redux-form 5 props
 * or manual props in this order.
 * @param {object} props - all PropTypes
 * @param {string} key - the property to look for
 * @param {string | null} [forcedPath=null] - an optional forced path to look for the property
 * @returns {any} - the value of the property
 */
export default function getPreferredProp(props, key) {
  let forcedPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let propsCopy = props;
  if (forcedPath) {
    propsCopy = get(props, forcedPath, {});
  }
  return get(propsCopy, `input.${key}`, get(propsCopy, `meta.${key}`, get(propsCopy, `field.${key}`, get(propsCopy, key, undefined))));
}
//# sourceMappingURL=getPreferredProp.js.map